import keycloak from 'keycloak-js';

export default keycloak({
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: process.env.REACT_APP_KEYCLOAK_AUTH_URL,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});
